import type { ReactNode } from 'react';

import type { TSectionElement } from '@shared/dream-components';
import { SectionElement } from '@shared/dream-components';
import classnames from 'classnames';

interface Props {
  node: TSectionElement;
  children: ReactNode | ReactNode[];
}

const Section = ({ node, children }: Props) => {
  // Handle legacy isHiddenInProduction field for backward compatibility
  // If new fields have non-undefined values, use them; otherwise fall back to legacy field
  const hideOnMobile =
    node.attrs?.hideOnMobile !== undefined ? node.attrs.hideOnMobile : node.attrs?.isHiddenInProduction;

  const hideOnDesktop =
    node.attrs?.hideOnDesktop !== undefined ? node.attrs.hideOnDesktop : node.attrs?.isHiddenInProduction;

  return (
    <div
      className={classnames({
        'hidden md:block': hideOnMobile, // Hidden on mobile, visible on md+ (768px+)
        'block md:hidden': hideOnDesktop, // Visible on mobile, hidden on md+ (768px+)
      })}
    >
      <SectionElement element={node}>{children}</SectionElement>
    </div>
  );
};

export default Section;
